import { Injectable, Inject, Optional } from '@angular/core';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import {
  setIsEmbed,
  setIsEmbedWordpress,
  setIsEmbedPrintEnabled,
  setIsEmmbedHeaderHidden,
  setTheme, setIsBrandingThemeDisabled
} from '../visual/visual.actions';

@Injectable({
  providedIn: 'root'
})
export class EmbedResolverService {

  constructor(
    public _store: Store<IAppState>,
    @Optional() @Inject(REQUEST) public request: any,
    @Inject('isBrowser') public isBrowser: boolean,
  ) { }

  resolve() {
    const url = this.isBrowser ? window.location.search : this.request.originalUrl;
    const isEmbed = this.detectIsEmbed(url);
    const isEmbedWordpress = this.detectIsEmbedWordpress(url);
    this._store.dispatch(setIsEmbed(isEmbed));
    this._store.dispatch(setIsEmbedWordpress(isEmbedWordpress));
    if(isEmbed) {
      const hideEmbedHeader = this.detectIsHideEmbedHeader(url);
      this._store.dispatch(setIsEmmbedHeaderHidden(hideEmbedHeader));
      const embedPrintEnabled = this.detectIsEmbedPrintEnabled(url);
      this._store.dispatch(setIsEmbedPrintEnabled(embedPrintEnabled));
      const isNightTheme = this.detectEmbedNightTheme(url);
      const isDayTheme = this.detectEmbedDayTheme(url);
      if (isNightTheme) {
        this._store.dispatch(setTheme('night'));
        this._store.dispatch(setIsBrandingThemeDisabled(true));
      }
      if (isDayTheme) {
        this._store.dispatch(setTheme('day'))
        this._store.dispatch(setIsBrandingThemeDisabled(true));
      }
    }
    return of(EMPTY);
  }

  detectIsEmbed(url) {
    return url.indexOf('embed') != -1;
  }

  detectIsEmbedWordpress(url) {
    return url.indexOf('wordpress=true') != -1;
  }

  detectIsHideEmbedHeader(url) {
    return url.indexOf('hide-header=true') != -1;
  }

  detectIsEmbedPrintEnabled(url) {
    return url.indexOf('print-enabled=true') != -1;
  }

  detectEmbedNightTheme(url) {
    return url.indexOf('theme=night') != -1;
  }

  detectEmbedDayTheme(url) {
    return url.indexOf('theme=day') != -1;
  }
}
